import { render, staticRenderFns } from "./PorTipoLegislacaoMensagemVeto.vue?vue&type=template&id=06c483e9&scoped=true"
import script from "./PorTipoLegislacaoMensagemVeto.vue?vue&type=script&lang=js"
export * from "./PorTipoLegislacaoMensagemVeto.vue?vue&type=script&lang=js"
import style0 from "./PorTipoLegislacaoMensagemVeto.vue?vue&type=style&index=0&id=06c483e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c483e9",
  null
  
)

export default component.exports